/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-eval */
/* eslint-disable array-callback-return */
import React, { Component } from 'react';
import { connect } from 'dva';
import { StoreState } from '@src/interfaces';
import {
  Modal,
  Col,
  Row,
  Avatar,
  Tag,
  Dropdown,
  Menu,
  Tooltip,
  Button,
  Space,
} from 'antd';
import { helper } from '@src/controls/controlHelper';
import ProTable from '@src/packages/pro-table/Table';
import _ from 'lodash';
import dayjs from 'dayjs';
import Widgets from '@src/packages/pro-component/schema/Widgets';
import FormCtrl from '@src/controls/layouts/schemaTemplate/FormCtrl';
import Loader from '@src/components/Loading';
// import * as request from '@src/util/request'
import { ColumnsState, RequestData, ActionType } from '@src/packages/pro-table';
import { DownOutlined } from '@ant-design/icons';
import {
  DATA_TYPE,
  DISPLAY_TYPE,
  GRID_EDITOR_FIELD,
} from '@src/constants/enums';
import NumberRange from '@src/packages/pro-component/schema/NumberRange';
import NumberMask from '@src/packages/pro-component/schema/NumberMask';
import { COLORS, IS_DEBUG } from '@src/constants/constants';
import { IButtonEditor } from '../../editors/ButtonEditor';
import {
  COLUMN_ACTIONS_FIELD,
  COLUMN_ACTIONS_NAME,
  COLUMN_ACTIONS_NAME_EN,
  COLUMN_ACTIONS_NAME_LA,
  DEFAULT_MENU_BUTTONS,
  DEFAULT_VIEW_DETAIL,
  IGridEditorColumn,
} from '../../editors/GridEditor';
import defaultRenderButton from '../../defaultRenderButton';
import { TablePaginationConfig } from 'antd/es/table';
import { SorterResult, TableCurrentDataSource } from 'antd/es/table/interface';
import clone from 'lodash/clone';
import { ResizableHeaderTitle } from '@src/packages/pro-utils';
import {
  defaultGridSetting,
  IPageEditorProps,
} from '@src/routes/default/pageManager/PageEditor';
import * as detailTemplateArray from '@src/controls/layouts/detailTemplate';
import { EyeOutlined } from '@ant-design/icons';
import HttpStatusCode from '@src/constants/HttpStatusCode';
import { FlashSaleVoucherCtrl, VoucherReminderFormCtrl } from '../schemaTemplate';
import ReportSoldVoucherCtrl from '@src/controls/layouts/gridTemplate/ReportSoldVoucher';
import VoucherReminderListCtrl from '@src/controls/layouts/gridTemplate/VoucherReminderListCtrl';
import { getLang } from '@src/packages/pro-table/component/util';

interface DetailTemplateArray {
  [key: string]: any;
}
const detailTemplates: DetailTemplateArray = detailTemplateArray;

export interface ListCtrlProps {
  query: any;
  pageInfo: any;
  authUser?: any;
}

export interface ListCtrlState {
  key: string;
  data: Array<any>;
  pageInfo: any;
  error: any;
  columns: Array<any>;
  modelSelect: Record<string, any>;
  modelSelectIds: Record<string, any>;
  currentFilter: Record<string, any>;
  tbl: any;
  modalQuery: Record<string, any>;
  isShowModal: boolean;
  tblFilter: Array<any>;
  currentModal: any;
  collapse?: boolean;
  filter?: any;
  mode?: any;
  loading?: boolean;
  count?: number;
  nPage?: number;
  pagination: Record<string, any>;
  fadeIn?: boolean;
  columnsStateMap: {
    [key: string]: ColumnsState;
  };
  viewDetail: {
    hasDetail: boolean;
    viewDetailCtrl: string;
    visible: boolean;
    record?: Record<string, any>;
  };
}

class ListCtrl extends Component<ListCtrlProps, ListCtrlState> {
  form = React.createRef<any>();
  actionRef = React.createRef<ActionType | undefined>();

  constructor(props: ListCtrlProps) {
    super(props);
    this.state = {
      key: 'id',
      data: [],
      pageInfo: null,
      error: null,
      columns: [],
      modelSelect: {},
      modelSelectIds: {},
      currentFilter: {},
      tbl: null,
      modalQuery: {},
      isShowModal: false,
      tblFilter: [],
      currentModal: null,
      columnsStateMap: {},
      pagination: {
        pageSize: this.itemsPerPage,
        total: 0,
        totalPages: 0,
        current: 1,
        position: [
          defaultGridSetting.paginationTop,
          defaultGridSetting.paginationBottom,
        ],
        showQuickJumper: defaultGridSetting.paginationShowQuickJumper,
        showSizeChanger: defaultGridSetting.paginationShowSizeChanger,
        simple: defaultGridSetting.paginationSimple,
        showTitle: defaultGridSetting.paginationShowTitle,
        showLessItems: defaultGridSetting.paginationShowLessItems,
        responsive: defaultGridSetting.paginationResponsive,
        size: defaultGridSetting.paginationSize,
      },
      viewDetail: {
        hasDetail: false,
        viewDetailCtrl: DEFAULT_VIEW_DETAIL,
        visible: false,
      },
    };
  }

  currentPage: any;
  itemsPerPage = 10;
  pageInfo: IPageEditorProps | null = null;
  /** Cursor stack: page → cursor dùng khi fetch trang đó (page 1 = không cursor) */
  private pageCursors: Record<number, number> = {};
  private cursorFilterKey = '';

  componentDidMount() {
    this.init(this.props);
  }

  componentDidUpdate(prevProps: ListCtrlProps) {
    if (
      prevProps.query !== this.props.query &&
      prevProps.pageInfo !== this.props.pageInfo
    ) {
      this.init(this.props);
    }
  }

  init = async (props: any) => {
    this.setState({ pageInfo: null });
    const pageInfo = props.pageInfo;
    if (!pageInfo) return helper.alert('Không tìm được trang');
    this.pageInfo = pageInfo;
    if (!Array.isArray(pageInfo.buttons)) pageInfo.buttons = [];
    if (!Array.isArray(pageInfo.grid)) pageInfo.grid = [];
    this.setState({
      pageInfo,
      mode: this.props.query.mode,
      loading: false,
    });
    if (!this.pageInfo) return;
    // await this.fetchData(this.state.pagination, {}, {})
    const columns = this.createColumnsData(this.pageInfo);
    const columnsStateMap = this.calculateColMap(this.pageInfo);
    const viewDetail = this.getViewDetailTemplate(this.pageInfo);
    this.setState({
      columns,
      columnsStateMap,
      viewDetail: {
        ...this.state.viewDetail,
        ...viewDetail,
      },
    });
  };

  getViewDetailTemplate = (pageInfo: IPageEditorProps) => {
    const viewDetail: any = {};
    for (
      let i = 0;
      i <
      pageInfo.grid.filter((col) => col.field !== COLUMN_ACTIONS_FIELD).length;
      i++
    ) {
      const gridInfo = pageInfo.grid[i];
      if (gridInfo.viewDetail) {
        viewDetail.hasDetail = true;
        viewDetail.viewDetailCtrl = gridInfo.viewDetailCtrl || 'DetailCtrl';
        break;
      }
    }
    return viewDetail;
  };

  search() {
    this.currentPage = 1;
    this.setState({ data: [], count: 0 });
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  handleFilterChange(name: any, val: any) {
    this.setState({ filter: { ...this.state.filter, [name]: val } });
  }

  toggleFade() {
    this.setState((prevState: any) => {
      return { fadeIn: !prevState.fadeIn };
    });
  }

  checkRequire(filter: any) {
    let rs = true;
    this.props.pageInfo.grid.map((i: any) => {
      if (i.required && !_.get(filter, i.field) && filter[i.field] == null) {
        rs = false;
      }
    });
    return rs;
  }

  /** field `meta.customerName` → ['meta','customerName'] for ProTable/antd nested get */
  toDataIndex = (field?: string) => {
    if (!field || typeof field !== 'string') return field;
    return field.includes('.') ? field.split('.') : field;
  };

  isPlainObjectValue = (val: any) =>
    val != null &&
    typeof val === 'object' &&
    !React.isValidElement(val) &&
    !Array.isArray(val) &&
    !dayjs.isDayjs(val) &&
    !(val instanceof Date);

  /** Flatten nested search form values: { meta: { phone: 'x' } } → { 'meta.phone': 'x' } */
  flattenFilterKeys = (input: Record<string, any>, prefix = ''): Record<string, any> => {
    const out: Record<string, any> = {};
    Object.keys(input || {}).forEach((k) => {
      const val = input[k];
      const path = prefix ? `${prefix}.${k}` : k;
      if (
        this.isPlainObjectValue(val) &&
        !('contains' in val) &&
        !('gte' in val) &&
        !('lte' in val) &&
        !('equals' in val)
      ) {
        Object.assign(out, this.flattenFilterKeys(val, path));
      } else {
        out[path] = val;
      }
    });
    return out;
  };

  renderObjectCell = (raw: any) => {
    const entries = Object.entries(raw || {});
    if (!entries.length) return '-';
    const summary = entries
      .slice(0, 3)
      .map(([k, v]) => `${k}: ${v}`)
      .join(', ');
    const more = entries.length > 3 ? ` (+${entries.length - 3})` : '';
    return (
      <Tooltip
        title={
          <pre style={{ margin: 0, maxHeight: 280, overflow: 'auto', fontSize: 12 }}>
            {JSON.stringify(raw, null, 2)}
          </pre>
        }
      >
        <span style={{ cursor: 'help' }}>
          {summary}
          {more}
        </span>
      </Tooltip>
    );
  };

  /** Format 1 field trong cột wrap theo type/display/enum/modelSelect */
  formatWrapFieldValue = (
    wf: any,
    raw: any,
    currentLocale: string
  ): React.ReactNode => {
    if (raw == null || raw === '') return null;

    const matchId = (a: any, b: any) =>
      a != null && b != null && String(a) === String(b);

    if (wf?.modelSelect) {
      const populateObj = this.state.modelSelect[wf.field];
      const populateObjData = populateObj?.data ?? [];
      const tagColor = wf.color || COLORS[3];

      if (wf.type === DATA_TYPE.ARRAY_IDS && _.isArray(raw)) {
        if (!raw.length) return null;
        const names = raw.map((id: any) => {
          const found = populateObjData.find((item: any) =>
            matchId(item.id, id)
          );
          return found ? found.name : id;
        });
        if (names.length <= 1) {
          return (
            <span style={{ display: 'inline-flex', flexWrap: 'wrap', gap: 4 }}>
              {names.map((name: string, index: number) => (
                <Tag key={index} color={tagColor}>
                  {name}
                </Tag>
              ))}
            </span>
          );
        }
        return (
          <span
            style={{
              display: 'inline-flex',
              flexWrap: 'wrap',
              gap: 4,
              alignItems: 'center',
            }}
          >
            <Tag color={tagColor}>{names[0]}</Tag>
            <Tooltip
              title={
                <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                  {names.map((name: string, index: number) => (
                    <div key={index} style={{ marginBottom: 4 }}>
                      <Tag color={tagColor} style={{ margin: 2 }}>
                        {name}
                      </Tag>
                    </div>
                  ))}
                </div>
              }
              placement="top"
            >
              <span style={{ color: '#1890ff', cursor: 'pointer' }}>
                +{names.length - 1}...
              </span>
            </Tooltip>
          </span>
        );
      }

      const found = populateObjData.find((item: any) =>
        matchId(item.id, raw)
      );
      const name = found ? found.name : String(raw);
      return <Tag color={tagColor}>{name}</Tag>;
    }

    if (wf?.enumable && Array.isArray(wf.items) && wf.items.length > 0) {
      const found = wf.items.find(
        (it: any) => String(it?.value) === String(raw)
      );
      const label = found
        ? this.getEnumItemLabel(found, currentLocale)
        : String(raw);
      if (wf.enumDisplayAs === 'tag') {
        return <Tag color={this.getEnumTagColor(found)}>{label}</Tag>;
      }
      return label;
    }

    const type = wf?.type || DATA_TYPE.STRING;
    const display = wf?.display || '';

    if (type === DATA_TYPE.DATE || String(display).toLowerCase().includes('date') || display === 'time') {
      const d = dayjs(raw);
      if (!d.isValid()) return String(raw);
      if (display === DISPLAY_TYPE.DATE_TIME || display === 'dateTime') {
        return d.format('DD/MM/YYYY HH:mm');
      }
      if (display === DISPLAY_TYPE.TIME || display === 'time') {
        return d.format('HH:mm:ss');
      }
      return d.format('DD/MM/YYYY');
    }

    if (type === DATA_TYPE.NUMBER) {
      const n = Number(raw);
      if (!Number.isFinite(n)) return String(raw);
      if (display === DISPLAY_TYPE.PERCENT || display === 'percent') {
        return `${n}%`;
      }
      if (display === DISPLAY_TYPE.MONEY || display === 'money') {
        return n.toLocaleString('vi-VN');
      }
      if (display === DISPLAY_TYPE.DIGIT || display === 'digit') {
        return n.toLocaleString('vi-VN');
      }
      // numberOnly (mặc định) — không phân tách nghìn
      return String(n);
    }

    if (type === DATA_TYPE.BOOLEAN) {
      const truthy =
        raw === true || raw === 1 || raw === '1' || raw === 'true';
      return truthy ? 'Có' : 'Không';
    }

    if (Array.isArray(raw)) return raw.join(', ');
    if (this.isPlainObjectValue(raw)) {
      return this.renderObjectCell(raw);
    }
    return String(raw);
  };

  /** Cột wrap nhiều field (inline / stack) */
  renderWrapFieldsCell = (gridInfo: any, record: any) => {
    const fields: any[] = Array.isArray(
      gridInfo[GRID_EDITOR_FIELD.WRAP_FIELDS]
    )
      ? gridInfo[GRID_EDITOR_FIELD.WRAP_FIELDS]
      : [];
    const sep =
      gridInfo[GRID_EDITOR_FIELD.WRAP_SEPARATOR] != null
        ? String(gridInfo[GRID_EDITOR_FIELD.WRAP_SEPARATOR])
        : ' · ';
    const layout =
      gridInfo[GRID_EDITOR_FIELD.WRAP_LAYOUT] === 'stack'
        ? 'stack'
        : 'inline';
    const locale = getLang();
    const currentLocale = locale.split('-')[0];

    const parts = fields
      .map((f, idx) => {
        if (!f?.field) return null;
        const raw = _.get(record, f.field);
        const content = this.formatWrapFieldValue(f, raw, currentLocale);
        if (content == null || content === '') return null;
        return {
          key: `${f.field}-${idx}`,
          label: f.hideLabelInTable ? undefined : f.label,
          content,
        };
      })
      .filter(Boolean) as Array<{
      key: string;
      label?: string;
      content: React.ReactNode;
    }>;

    if (!parts.length) return '-';

    if (layout === 'stack') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {parts.map((p) => (
            <div key={p.key} style={{ lineHeight: 1.4 }}>
              {p.label ? (
                <span style={{ color: '#8c8c8c', marginRight: 4 }}>
                  {p.label}:
                </span>
              ) : null}
              <span>{p.content}</span>
            </div>
          ))}
        </div>
      );
    }

    return (
      <span style={{ display: 'inline-flex', flexWrap: 'wrap', alignItems: 'center' }}>
        {parts.map((p, i) => (
          <span key={p.key} style={{ display: 'inline-flex', alignItems: 'center' }}>
            {i > 0 ? <span>{sep}</span> : null}
            {p.label ? (
              <span style={{ color: '#8c8c8c', marginRight: 4 }}>
                {p.label}
              </span>
            ) : null}
            {p.content}
          </span>
        ))}
      </span>
    );
  };

  getEnumItemLabel = (item: any, currentLocale: string) => {
    if (
      item?.key &&
      item.key.includes('&') &&
      item.key.includes(`${currentLocale}=`)
    ) {
      let itemValue = item.key;
      item.key.split(`&`).forEach((lang: string) => {
        if (lang.includes(`${currentLocale}=`)) {
          itemValue = lang.split(`=`)[1];
        }
      });
      return itemValue;
    }
    return item?.key ?? item?.value ?? '';
  };

  /** Map status GridEditor → màu Ant Tag */
  getEnumTagColor = (item: any) => {
    if (!item) return undefined;
    if (item.status === 'Custom' && item.color) return item.color;
    const map: Record<string, string> = {
      Success: 'success',
      Error: 'error',
      Processing: 'processing',
      Warning: 'warning',
      Default: 'default',
    };
    return map[item.status] || item.color || undefined;
  };

  /** Gắn prefix/suffix quanh giá trị cột (cố định hoặc map theo cột khác + màu) */
  resolveAffixMap = (
    record: any,
    byField?: string,
    items?: Array<{ value: any; text?: string; color?: string }>,
    fallbackText?: string,
    fallbackColor?: string
  ) => {
    if (byField && Array.isArray(items) && items.length > 0) {
      const depVal = _.get(record, byField);
      const found = items.find(
        (i) => i != null && String(i.value) === String(depVal)
      );
      if (found) {
        return {
          text: found.text != null ? String(found.text) : '',
          color: found.color || undefined,
        };
      }
      return { text: '', color: undefined };
    }
    return {
      text: fallbackText ? String(fallbackText) : '',
      color: fallbackColor || undefined,
    };
  };

  wrapWithAffix = (content: any, gridInfo: any, record?: any) => {
    const prefixRes = this.resolveAffixMap(
      record,
      gridInfo?.[GRID_EDITOR_FIELD.PREFIX_BY_FIELD],
      gridInfo?.[GRID_EDITOR_FIELD.PREFIX_ITEMS],
      gridInfo?.[GRID_EDITOR_FIELD.PREFIX],
      gridInfo?.[GRID_EDITOR_FIELD.PREFIX_COLOR]
    );
    const suffixRes = this.resolveAffixMap(
      record,
      gridInfo?.[GRID_EDITOR_FIELD.SUFFIX_BY_FIELD],
      gridInfo?.[GRID_EDITOR_FIELD.SUFFIX_ITEMS],
      gridInfo?.[GRID_EDITOR_FIELD.SUFFIX],
      gridInfo?.[GRID_EDITOR_FIELD.SUFFIX_COLOR]
    );
    const prefix = prefixRes.text;
    const suffix = suffixRes.text;
    // Màu: ưu tiên map/cố định prefix, sau đó suffix
    const color = prefixRes.color || suffixRes.color;

    if (!prefix && !suffix && !color) return content;
    if (Array.isArray(content)) return content;
    if (content == null || content === '' || content === '-') return content;

    return (
      <span style={color ? { color } : undefined}>
        {prefix ? <span className='gx-col-prefix'>{prefix}</span> : null}
        {content}
        {suffix ? <span className='gx-col-suffix'>{suffix}</span> : null}
      </span>
    );
  };

  onResize =
    (index: number) =>
      (e: any, { size }: any) => {
        const nextColumns = clone(this.state.columns);
        nextColumns[index] = {
          ...nextColumns[index],
          width: size.width,
        };
        this.setState({ columns: nextColumns });
      };

  onTableChange = (
    changePagination: TablePaginationConfig,
    _filters: {
      [string: string]: any;
    },
    _sorter: SorterResult<any> | SorterResult<any>[],
    _extra: TableCurrentDataSource<any>
  ) => {
    const _pagi = clone(this.state.pagination);
    this.setState({
      pagination: {
        ..._pagi,
        ...changePagination,
      },
    });
  };

  fetchData = async (
    params: any,
    sorter: {
      [key: string]: 'ascend' | 'descend';
    },
    filtered: { [key: string]: React.ReactText[] }
  ): Promise<RequestData<any>> => {
    if (IS_DEBUG) {
      console.log(`🚀 ~ file: ListCtrl.tsx ~ line 138 ~ params`, params);
      console.log(`🚀 ~ file: ListCtrl.tsx ~ line 137 ~ filtered`, filtered);
      console.log(`🚀 ~ file: ListCtrl.tsx ~ line 138 ~ sorter`, sorter);
    }

    const _filtered = Object.keys(filtered).reduce((obj, key) => {
      const newObj: any = { ...obj };
      if (filtered[key] !== null) newObj[key] = helper.getValue(filtered[key]);
      return newObj;
    }, {});
    const _params = _.omit(params, [
      'current',
      'pageSize',
      'showSizeChanger',
      'total',
      'totalPages',
      'position',
    ]);
    const flatFiltered = this.flattenFilterKeys({
      ..._params,
      ..._filtered,
    });
    const tbl = {
      params,
      sorter,
      filtered: flatFiltered,
    };
    if (tbl) {
      this.setState({ tbl });
    }
    if (this.state.loading || !this.pageInfo) {
      return {
        data: [],
        success: true,
        total: 0,
      } as RequestData<any>;
    }
    this.setState({ loading: true });
    let filter = {},
      skip = 0,
      limit = this.itemsPerPage,
      sort: Array<any> = [];

    if (tbl && tbl.filtered) {
      filter = this.calculateFilter(tbl.filtered);
      skip = tbl.params.pageSize * (tbl.params.current - 1);
      limit = tbl.params.pageSize;
    }

    if (!this.checkRequire(filter)) {
      this.setState({ loading: false, data: [] });
      return {
        data: [],
        success: true,
        total: 0,
      } as RequestData<any>;
    }
    if (tbl && tbl.sorter) {
      sort = Object.keys(tbl.sorter).map((key) => {
        return { [key]: tbl.sorter[key] === 'descend' ? 'desc' : 'asc' };
      });
    }
    if (sort.length === 0) sort = [{ id: 'desc' }];
    if (this.props.query.filter) {
      Object.assign(filter, JSON.parse(this.props.query.filter));
    }

    const input: Record<string, any> = {
      queryInput: JSON.stringify(filter),
      limit,
      skip,
    };
    if (sort) {
      input.sort = JSON.stringify(sort);
    }

    const useCursor = !!this.pageInfo?.settings?.grid?.useCursor;
    const currentPage = tbl?.params?.current || 1;
    if (useCursor) {
      const filterKey = JSON.stringify({
        filter,
        sort,
        pageSize: limit,
      });
      if (this.cursorFilterKey !== filterKey) {
        this.cursorFilterKey = filterKey;
        this.pageCursors = {};
      }
      const cursorForPage = this.pageCursors[currentPage];
      if (cursorForPage) {
        // Next tuần tự: dùng cursor đã lưu từ trang trước
        input.useCursor = 1;
        input.cursor = cursorForPage;
        input.skip = 0;
      } else if (currentPage === 1) {
        // Trang 1: bật cursor mode để BE trả nextCursor
        input.useCursor = 1;
        input.skip = 0;
      } else {
        // Cursor không hỗ trợ nhảy cách trang → luôn về trang 1 (không fallback skip)
        tbl.params.current = 1;
        input.useCursor = 1;
        input.skip = 0;
        delete input.cursor;
      }
    }

    const effectivePage = useCursor
      ? Number(tbl?.params?.current || 1)
      : currentPage;

    const rs: any = await helper.callPageApi(
      this.pageInfo,
      this.pageInfo.read,
      input
    );
    const data = rs?.data?.data ?? [];

    if (useCursor) {
      const nextCursor = rs?.data?.nextCursor;
      if (nextCursor != null && Number(nextCursor) > 0) {
        this.pageCursors[effectivePage + 1] = Number(nextCursor);
      } else {
        Object.keys(this.pageCursors).forEach((k) => {
          if (Number(k) > effectivePage) {
            delete this.pageCursors[Number(k)];
          }
        });
      }
    }

    const modelSelect: any = {};
    const modelSelectIds: any = {};

    type ModelSelectSource = {
      key: string;
      field: string;
      modelSelectApi: string;
      type?: string;
    };
    const selectSources: ModelSelectSource[] = [];
    const pushSource = (src: ModelSelectSource) => {
      if (!src.field || !src.modelSelectApi) return;
      if (
        selectSources.some(
          (s) => s.key === src.key && s.modelSelectApi === src.modelSelectApi
        )
      ) {
        return;
      }
      selectSources.push(src);
    };

    (this.pageInfo?.grid || []).forEach((g: any) => {
      if (g.modelSelect && g.modelSelectApi && g.field) {
        pushSource({
          key: g.field,
          field: g.field,
          modelSelectApi: g.modelSelectApi,
          type: g.type,
        });
      }
      (g.wrapFields || []).forEach((wf: any) => {
        if (wf?.modelSelect && wf?.modelSelectApi && wf?.field) {
          pushSource({
            key: wf.field,
            field: wf.field,
            modelSelectApi: wf.modelSelectApi,
            type: wf.type,
          });
        }
      });
    });

    const collectId = (key: string, id: any) => {
      if (id == null || id === '') return;
      if (!modelSelectIds[key]) modelSelectIds[key] = [];
      if (!_.includes(modelSelectIds[key], id)) {
        modelSelectIds[key].push(id);
      }
    };

    data.forEach((d: any) => {
      selectSources.forEach((src) => {
        const fieldVal = _.get(d, src.field);
        if (src.type === DATA_TYPE.ARRAY_IDS) {
          if (_.isArray(fieldVal)) {
            fieldVal.forEach((id: any) => collectId(src.key, id));
          }
        } else {
          collectId(src.key, fieldVal);
        }
      });
    });

    const promises: Promise<any>[] = [];
    const gInfos: ModelSelectSource[] = [];
    selectSources.forEach((src) => {
      if (!(modelSelectIds[src.key] && modelSelectIds[src.key].length > 0)) {
        return;
      }
      gInfos.push(src);
      promises.push(
        helper.callPageApi(this.pageInfo, src.modelSelectApi, {
          queryInput: JSON.stringify({ id: modelSelectIds[src.key] }),
        })
      );
    });
    const fieldNameRs: Array<any> = await Promise.all(promises);
    for (let i = 0; i < gInfos.length; i++) {
      const gInfo = gInfos[i];
      modelSelect[gInfo.key] = fieldNameRs[i].data;
    }

    await this.setState({
      data,
      modelSelect,
      count: rs?.data.count,
      loading: false,
      nPage: Math.ceil(rs?.data.count / limit),
      currentFilter: input,
      pagination: {
        ...this.state.pagination,
        position: [
          this?.pageInfo?.settings?.grid?.paginationTop ??
          defaultGridSetting.paginationTop,
          this?.pageInfo?.settings?.grid?.paginationBottom ??
          defaultGridSetting.paginationBottom,
        ],
        pageSize: params.pageSize,
        total: rs?.data.count,
        totalPages: Math.floor(
          (_.get(rs, 'data.count', 0) + tbl?.params?.pageSize - 1) /
          tbl?.params?.pageSize
        ),
        current: useCursor ? effectivePage : tbl?.params?.current,
        // Cursor: chỉ prev/next tuần tự, không nhảy số trang (tránh skip/limit)
        simple: useCursor
          ? true
          : (this?.pageInfo?.settings?.grid?.paginationSimple ??
            defaultGridSetting.paginationSimple),
        showQuickJumper: useCursor
          ? false
          : (this?.pageInfo?.settings?.grid?.paginationShowQuickJumper ??
            defaultGridSetting.paginationShowQuickJumper),
      },
    });
    return {
      data,
      success: true,
      total: rs?.data.count,
    } as RequestData<any>;
  };

  /** Meta field dùng cho calculateFilter (cột thường hoặc wrap field filterable) */
  resolveFilterFieldMeta = (fieldKey: string) => {
    const grid = (this.pageInfo || {}).grid || [];
    for (let i = 0; i < grid.length; i++) {
      const gridInfo = grid[i];
      if (gridInfo.field === fieldKey) {
        return gridInfo;
      }
    }
    for (let i = 0; i < grid.length; i++) {
      const gridInfo = grid[i];
      const wf: any = (gridInfo.wrapFields || []).find(
        (w: any) => w?.filterable && w?.field === fieldKey
      );
      if (wf) {
        return {
          field: wf.field,
          type: wf.type || DATA_TYPE.STRING,
          display: wf.display,
          modelSelect: wf.modelSelect,
          modelSelectApi: wf.modelSelectApi,
          enumable: wf.enumable,
          items: wf.items,
          filterRange: wf.filterRange,
          accurate: wf.accurate,
        };
      }
    }
    return null;
  };

  /** Cột ẩn trên table, chỉ dùng cho form search của wrap field */
  buildWrapSearchColumn = (wf: any, currentLocale: string) => {
    if (!wf?.filterable || !wf?.field) return null;
    const type = wf.type || DATA_TYPE.STRING;
    // key phải = field thật (giống cột thường) vì Form.Item name = genColumnKey(key, dataIndex)
    const item: any = {
      title: wf.label || wf.field,
      key: wf.field,
      dataIndex: this.toDataIndex(wf.field),
      hideInTable: true,
      hideInSetting: true,
      hideInSearch: false,
      sorter: false,
      filters: false,
    };

    // valueType / form giống cột 1 field
    const pseudoGrid = {
      ...wf,
      field: wf.field,
      type,
      display: wf.display,
      filterRange: wf.filterRange,
      modelSelect: wf.modelSelect,
      modelSelectApi: wf.modelSelectApi,
      enumable: wf.enumable,
      items: wf.items,
    };

    if (wf.display) {
      item.valueType = wf.display;
    } else {
      switch (type) {
        case DATA_TYPE.BOOLEAN:
          item.valueType = DISPLAY_TYPE.SWITCH;
          break;
        case DATA_TYPE.DATE:
          item.valueType = DISPLAY_TYPE.DATE;
          break;
        case DATA_TYPE.NUMBER:
          item.valueType = DISPLAY_TYPE.NUMBER_ONLY;
          break;
        case DATA_TYPE.ARRAY_IDS:
          item.valueType = DISPLAY_TYPE.ARRAY_IDS;
          break;
        default:
          item.valueType = DISPLAY_TYPE.TEXT;
          break;
      }
    }

    this.generateDisplay(item, pseudoGrid);

    if (wf.enumable && Array.isArray(wf.items) && wf.items.length > 0) {
      item.valueEnum = wf.items.reduce((prev: any, cur: any) => {
        return {
          ...prev,
          [cur.value]: this.getEnumItemLabel(cur, currentLocale),
        };
      }, {});
    } else if (wf.modelSelect) {
      item.renderFormItem = (_: any, { type: formType }: any) => {
        if (formType === 'form') {
          return null;
        }
        return (
          <Widgets.ArraySelect
            type='checkbox'
            schema={{
              modelSelectField:
                currentLocale === 'la'
                  ? 'id$$ID,name$$ຊື່'
                  : currentLocale === 'en'
                    ? 'id,name'
                    : 'id$$ID,name$$Tên',
              pageId: (this.pageInfo ?? {}).id,
              api: wf.modelSelectApi,
            }}
          />
        );
      };
    }

    return item;
  };

  calculateFilter(filter: { [key: string]: React.ReactText[] }) {
    const obj: any = {};
    Object.keys(filter).map((f: any) => {
      const value: any = filter[f];
      if (value === undefined || value === null || value === '') {
        return 0;
      }
      // Hỗ trợ key cũ __wrap_filter__field nếu còn cache
      const fieldKey = String(f).startsWith('__wrap_filter__')
        ? String(f).replace(/^__wrap_filter__/, '')
        : f;
      const gridInfo = this.resolveFilterFieldMeta(fieldKey);
      if (!gridInfo) {
        return 0;
      }
      const outKey = fieldKey;
      if (gridInfo.modelSelect) {
        if (_.isArray(value) && value.length > 0) {
          obj[outKey] = value;
        } else if (!_.isArray(value) && value != null && value !== '') {
          obj[outKey] = value;
        }
      } else {
        switch (gridInfo.type) {
          case DATA_TYPE.STRING:
            if (gridInfo.enumable) {
              obj[outKey] = value;
            } else if (gridInfo.accurate) {
              obj[outKey] = value;
            } else {
              obj[outKey] = { contains: value };
            }
            break;
          case 'integer':
          case DATA_TYPE.NUMBER:
            if (gridInfo.filterRange) {
              if (_.isArray(value)) {
                if (value[0]) {
                  if (!obj[outKey]) obj[outKey] = {};
                  obj[outKey]['gte'] = Number(value[0]);
                }
                if (value[1]) {
                  if (!obj[outKey]) obj[outKey] = {};
                  obj[outKey]['lte'] = Number(value[1]);
                }
              }
            } else {
              const n = Number(
                typeof value === 'string'
                  ? value.replace(/\./g, '').replace(/,/g, '')
                  : value
              );
              if (Number.isFinite(n)) {
                obj[outKey] = n;
              }
            }
            break;
          case DATA_TYPE.BOOLEAN:
            obj[outKey] =
              value === true || value === 'true' || value === 1
                ? true
                : false;
            break;
          case DATA_TYPE.DATE:
            if (
              gridInfo.filterRange ||
              gridInfo[GRID_EDITOR_FIELD.DISPLAY] ===
                DISPLAY_TYPE.DATE_RANGE ||
              gridInfo[GRID_EDITOR_FIELD.DISPLAY] ===
                DISPLAY_TYPE.DATE_TIME_RANGE ||
              gridInfo.display === DISPLAY_TYPE.DATE_RANGE ||
              gridInfo.display === DISPLAY_TYPE.DATE_TIME_RANGE
            ) {
              if (Array.isArray(value) && value.length === 2) {
                const [startText, endText] = value;
                if (startText) {
                  if (!obj[outKey]) obj[outKey] = {};
                  obj[outKey]['gte'] = dayjs(startText).valueOf();
                }
                if (endText) {
                  if (!obj[outKey]) obj[outKey] = {};
                  obj[outKey]['lte'] = dayjs(endText).valueOf();
                }
              }
            } else {
              if (value) {
                obj[outKey] = {
                  gte: dayjs(value).startOf('day').valueOf(),
                  lte: dayjs(value).endOf('day').valueOf(),
                };
              }
            }
            break;
          default:
            // enum / text
            if (gridInfo.enumable) {
              obj[outKey] = value;
            } else {
              obj[outKey] = { contains: value };
            }
            break;
        }
      }
      return 0;
    });
    return obj;
  }

  onChange(data: any) {
    this.setState({ data });
  }

  onButtonClick = async (btnInfo: IButtonEditor, data: any) => {
    try {
      let i;
      switch (btnInfo.action) {
        case 'api': {
          if (!data) data = {};
          if (this.props.query.embed && btnInfo.embedUrl) {
            Object.assign(data, JSON.parse(this.props.query.embed));
          }
          if (!btnInfo?.api) {
            helper.alert('Thiếu api', 'warning');
          } else {
            const response: any = await helper.callPageApi(
              this.pageInfo,
              btnInfo.api,
              data
            );
            console.log('🚀 ~ file: ListCtrl.tsx ~ line 526 ~ onButtonClick= ~ response', response);
            if (
              response.status === HttpStatusCode.OK &&
              !response?.data?.errorCode
            ) {
              helper.alert(response?.data.message || 'Thành công', 'success');
            } else {
              if (typeof response?.data?.errorCode == 'number') {
                helper.alert(
                  response?.data.message || 'Đã có lỗi xảy ra',
                  'error'
                );
              } else if (response?.data?.issues && response?.data?.issues.length > 0) {
                helper.alert(
                  response?.data.issues.map((issue: any) => issue.message).join('\n'),
                  'error'
                );
              } else {
                helper.alert('Đã có lỗi xảy ra', 'error');
              }
            }
          }
          this.reloadTable();
          break;
        }
        case 'formModal': {
          let raw = btnInfo.modalQuery;
          if (!raw) {
            helper.alert('Thiếu modalQuery', 'warning');
          } else {
            for (i in data) {
              raw = helper.replaceAll(raw, '#' + i + '#', data[i]);
            }
            const query = JSON.parse(raw);
            if (!query.modalType) query.modalType = 'form';
            let currentModal: any;
            switch (query.modalType) {
              case 'FlashSaleVoucherCtrl':
                currentModal = FlashSaleVoucherCtrl;
                break;
              case 'ReportSoldVoucherCtrl':
                currentModal = ReportSoldVoucherCtrl;
                break;
              case 'VoucherReminderFormCtrl':
                currentModal = VoucherReminderFormCtrl;
                break;
              case 'VoucherReminderListCtrl':
                currentModal = VoucherReminderListCtrl;
                break;
              case 'form':
              default:
                currentModal = FormCtrl;
                break;
            }
            this.setState({
              isShowModal: true,
              modalQuery: query,
              currentModal,
            });
          }
          break;
        }
        default:
          break;
      }
    } catch (err: any) {
      helper.alert(err.message || 'Có lỗi xảy ra!', 'error');
    }
  };
  reloadTable = () => {
    if (this.actionRef && this.actionRef.current) {
      this.actionRef.current.reload();
    }
  };

  calculateColMap = (pageInfo: any) => {
    const colsMap: any = {};
    for (let i = 0; i < pageInfo.grid.length; i++) {
      const gridInfo = pageInfo.grid[i];
      // show
      if (typeof gridInfo[GRID_EDITOR_FIELD.HIDE_IN_SETTING] == 'boolean') {
        colsMap[gridInfo[GRID_EDITOR_FIELD.FIELD]] = {
          show: !gridInfo[GRID_EDITOR_FIELD.HIDE_IN_SETTING],
        };
      } else {
        colsMap[gridInfo[GRID_EDITOR_FIELD.FIELD]] = {
          show: true,
        };
      }
      // fixed / freeze
      if (
        gridInfo[GRID_EDITOR_FIELD.FIXED] &&
        gridInfo[GRID_EDITOR_FIELD.FIXED] !== 'none'
      ) {
        if (colsMap[gridInfo[GRID_EDITOR_FIELD.FIELD]]) {
          Object.assign(colsMap[gridInfo[GRID_EDITOR_FIELD.FIELD]], {
            fixed: gridInfo[GRID_EDITOR_FIELD.FIXED],
          });
        } else {
          colsMap[gridInfo[GRID_EDITOR_FIELD.FIELD]] = {
            fixed: gridInfo[GRID_EDITOR_FIELD.FIXED],
          };
        }
      } else if (colsMap[gridInfo[GRID_EDITOR_FIELD.FIELD]]) {
        // clear stale freeze when set back to none
        colsMap[gridInfo[GRID_EDITOR_FIELD.FIELD]].fixed = undefined;
      }
    }
    return colsMap;
  };

  generateDisplay = (item: any, gridInfo: any) => {
    const type = gridInfo.display ? gridInfo.display : item.valueType;
    switch (type) {
      case DISPLAY_TYPE.MONEY:
        if (gridInfo.filterRange) {
          item.renderFormItem = (_: any, { type }: any) => {
            if (type === 'form') {
              return null;
            }
            return <NumberRange type='money' placeholder={['Từ', 'Đến']} />;
          };
        }
        break;
      case DISPLAY_TYPE.TEXTAREA:
        break;
      case DISPLAY_TYPE.OPTION:
        break;
      case DISPLAY_TYPE.DATE:
        break;
      case DISPLAY_TYPE.DATE_RANGE:
        break;
      case DISPLAY_TYPE.DATE_TIME:
        break;
      case DISPLAY_TYPE.DATE_TIME_RANGE:
        break;
      case DISPLAY_TYPE.TIME:
        break;
      case DISPLAY_TYPE.TEXT:
        break;
      case DISPLAY_TYPE.INDEX:
        break;
      case DISPLAY_TYPE.INDEX_BORDER:
        break;
      case DISPLAY_TYPE.PROGRESS:
        if (gridInfo.filterRange) {
          item.renderFormItem = (_: any, { type }: any) => {
            if (type === 'form') {
              return null;
            }
            return (
              <NumberRange
                mask={``}
                type='process'
                placeholder={['Từ', 'Đến']}
              />
            );
          };
        }
        break;
      case DISPLAY_TYPE.PERCENT:
        if (gridInfo.filterRange) {
          item.renderFormItem = (_: any, { type }: any) => {
            if (type === 'form') {
              return null;
            }
            return <NumberRange type={`percent`} placeholder={['Từ', 'Đến']} />;
          };
        }
        break;
      case DISPLAY_TYPE.DIGIT:
        if (gridInfo.filterRange) {
          item.renderFormItem = (_: any, { type }: any) => {
            if (type === 'form') {
              return null;
            }
            return (
              <NumberRange type='digit' mask={``} placeholder={['Từ', 'Đến']} />
            );
          };
        }
        break;
      case DISPLAY_TYPE.NUMBER_ONLY:
        // Không format phân tách nghìn trên table / form
        item.render = (value: any) => {
          if (value == null || value === '') return '-';
          return String(value);
        };
        if (gridInfo.filterRange) {
          item.renderFormItem = (_: any, { type }: any) => {
            if (type === 'form') {
              return null;
            }
            return (
              <NumberRange
                type='numberOnly'
                mask={``}
                placeholder={['Từ', 'Đến']}
              />
            );
          };
        } else {
          item.renderFormItem = (_: any, { type }: any) => {
            if (type === 'form') {
              return null;
            }
            return <NumberMask type='numberOnly' mask='' />;
          };
        }
        break;
      case DISPLAY_TYPE.AVATAR:
        item.render = (value: any) => {
          if (_.isArray(value)) {
            return (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                }}
              >
                <div style={{ textTransform: 'uppercase' }}>
                  <Avatar src={_.get(value, '[0]', '')} />
                </div>
              </div>
            );
          } else {
            return (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                }}
              >
                <div style={{ textTransform: 'uppercase' }}>
                  <Avatar src={value} />
                </div>
              </div>
            );
          }
        };
        break;
      case DISPLAY_TYPE.CODE:
        break;
      case DISPLAY_TYPE.SWITCH:
        break;
      case DISPLAY_TYPE.RADIO:
        break;
      case DISPLAY_TYPE.RADIO_BUTTON:
        break;
      case DISPLAY_TYPE.ARRAY_IDS:
        item.render = (_dom: any, record: any) => {
          const value = record?.[gridInfo.field];
          if (!_.isArray(value) || value.length === 0) {
            return <span>-</span>;
          }

          // Nếu có modelSelectApi, lấy dữ liệu từ API để hiển thị tên
          if (gridInfo.modelSelectApi) {
            const populateObj = this.state.modelSelect[gridInfo.field];
            const populateObjData = populateObj?.data ?? [];

            // Tìm các tên tương ứng với IDs
            const names = value.map((id: any) => {
              const found = populateObjData.find(
                (item: any) =>
                  item.id != null && id != null && String(item.id) === String(id)
              );
              return found ? found.name : id;
            });

            // Hiển thị tối đa 1 items, nếu nhiều hơn thì thêm dấu 3 chấm
            if (names.length <= 1) {
              return (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                  {names.map((name: string, index: number) => (
                    <Tag key={index} color={gridInfo.color || COLORS[3]}>
                      {name}
                    </Tag>
                  ))}
                </div>
              );
            } else {
              return (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center' }}>
                  {names.slice(0, 1).map((name: string, index: number) => (
                    <Tag key={index} color={gridInfo.color || COLORS[3]}>
                      {name}
                    </Tag>
                  ))}
                  <Tooltip
                    title={
                      <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                        {names.map((name: string, index: number) => (
                          <div key={index} style={{ marginBottom: '4px' }}>
                            <Tag color={gridInfo.color || COLORS[3]} style={{ margin: '2px' }}>
                              {name}
                            </Tag>
                          </div>
                        ))}
                      </div>
                    }
                    placement="top"
                    overlayStyle={{ maxWidth: '300px' }}
                  >
                    <span
                      style={{
                        marginLeft: '4px',
                        color: '#1890ff',
                        cursor: 'pointer',
                        textDecoration: 'underline'
                      }}
                    >
                      +{names.length - 1} more
                    </span>
                  </Tooltip>
                </div>
              );
            }
          } else {
            // Nếu không có API, hiển thị trực tiếp IDs
            if (value.length <= 1) {
              return (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                  {value.map((id: any, index: number) => (
                    <Tag key={index} color={gridInfo.color || COLORS[3]}>
                      {id}
                    </Tag>
                  ))}
                </div>
              );
            } else {
              return (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center' }}>
                  {value.slice(0, 1).map((id: any, index: number) => (
                    <Tag key={index} color={gridInfo.color || COLORS[3]}>
                      {id}
                    </Tag>
                  ))}
                  <Tooltip
                    title={
                      <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                        {value.map((id: any, index: number) => (
                          <div key={index} style={{ marginBottom: '4px' }}>
                            <Tag color={gridInfo.color || COLORS[3]} style={{ margin: '2px' }}>
                              {id}
                            </Tag>
                          </div>
                        ))}
                      </div>
                    }
                    placement="top"
                    overlayStyle={{ maxWidth: '300px' }}
                  >
                    <span
                      style={{
                        marginLeft: '4px',
                        color: '#1890ff',
                        cursor: 'pointer',
                        textDecoration: 'underline'
                      }}
                    >
                      +{value.length - 1} more
                    </span>
                  </Tooltip>
                </div>
              );
            }
          }
        };

        break;
      default:
        break;
    }
    return item;
  };

  hasColumn = (name: string, pageInfo: any) => {
    const findCol = pageInfo.grid.find(
      (item: any) => item.field[name] === name
    );
    if (findCol) {
      return true;
    }
    return false;
  };

  getColumnTitle = (gridInfo: any, currentLocale: string) => {
    switch (currentLocale) {
      case 'en':
        return gridInfo.nameEn || gridInfo.name;
      case 'la':
        return gridInfo.nameLa || gridInfo.name;
      default:
        return gridInfo.name;
    }
  };

  getActionTitle = (currentLocale: string) => {
    switch (currentLocale) {
      case 'en':
        return COLUMN_ACTIONS_NAME_EN;
      case 'la':
        return COLUMN_ACTIONS_NAME_LA;
      default:
        return COLUMN_ACTIONS_NAME;
    }
  };

  createColumnsData = (pageInfo: IPageEditorProps) => {
    const locale = getLang();
    const currentLocale = locale.split('-')[0];
    const columns = [];
    for (
      let i = 0;
      i <
      pageInfo.grid.filter((col) => col.field !== COLUMN_ACTIONS_FIELD).length;
      i++
    ) {
      const gridInfo = pageInfo.grid[i];
      const item: any = {
        title: this.getColumnTitle(gridInfo, currentLocale),
        key: gridInfo.field,
        dataIndex: this.toDataIndex(gridInfo.field),
        sorter: gridInfo[GRID_EDITOR_FIELD.SORTER] || true, // sorter: sắp xếp
        hideInTable: gridInfo[GRID_EDITOR_FIELD.HIDE_IN_TABLE] || false,
        filters: gridInfo[GRID_EDITOR_FIELD.FILTERS] || false,
        onHeaderCell: (column: any) => ({
          width: column.width,
          onResize: this.onResize(i),
        }),
      };
      //default width
      item.width = 100;
      // valueType: loại hiển thị
      if (gridInfo[GRID_EDITOR_FIELD.DISPLAY]) {
        item.valueType = gridInfo[GRID_EDITOR_FIELD.DISPLAY];
      }
      // copyable: hiển thị nút copy
      if (typeof gridInfo[GRID_EDITOR_FIELD.COPYABLE] == 'boolean') {
        item.copyable = gridInfo[GRID_EDITOR_FIELD.COPYABLE];
      }
      // ellipsis: hiển thị dang ellipsis
      if (typeof gridInfo[GRID_EDITOR_FIELD.ELLIPSIS] == 'boolean') {
        item.ellipsis = gridInfo[GRID_EDITOR_FIELD.ELLIPSIS];
      }
      if (gridInfo.type === DATA_TYPE.DATE) {
        // độ rộng mặc định nếu là date
        item.width = 150;
      }
      // width: thiết lập độ rộng
      if (gridInfo.width) item.width = Number(gridInfo.width);
      // freeze / fixed cột (config từ GridEditor)
      if (
        gridInfo[GRID_EDITOR_FIELD.FIXED] &&
        gridInfo[GRID_EDITOR_FIELD.FIXED] !== 'none'
      ) {
        item.fixed = gridInfo[GRID_EDITOR_FIELD.FIXED];
      }
      // hideInSearch: search trên form
      if (typeof gridInfo[GRID_EDITOR_FIELD.FILTERABLE] == 'boolean') {
        item.hideInSearch = !gridInfo[GRID_EDITOR_FIELD.FILTERABLE];
      } else if (typeof gridInfo[GRID_EDITOR_FIELD.FILTERABLE] == 'undefined') {
        item.hideInSearch = true;
      }
      switch (gridInfo.type) {
        case DATA_TYPE.BOOLEAN:
          // valueType: loại hiển thị default
          if (!gridInfo[GRID_EDITOR_FIELD.DISPLAY]) {
            item.valueType = DISPLAY_TYPE.SWITCH;
          }
          break;
        case DATA_TYPE.DATE:
          // valueType: loại hiển thị default
          if (!gridInfo[GRID_EDITOR_FIELD.DISPLAY]) {
            item.valueType = DISPLAY_TYPE.DATE;
          }
          this.generateDisplay(item, gridInfo);
          break;
        case DATA_TYPE.NUMBER:
          // valueType: loại hiển thị default
          if (!gridInfo[GRID_EDITOR_FIELD.DISPLAY]) {
            item.valueType = DISPLAY_TYPE.NUMBER_ONLY;
          }
          this.generateDisplay(item, gridInfo);
          break;
        case DATA_TYPE.STRING:
          // valueType: loại hiển thị default
          if (!gridInfo[GRID_EDITOR_FIELD.DISPLAY]) {
            item.valueType = DISPLAY_TYPE.TEXT;
          }
          this.generateDisplay(item, gridInfo);
          break;
        case DATA_TYPE.ARRAY_IDS:
          // valueType: loại hiển thị default
          if (!gridInfo[GRID_EDITOR_FIELD.DISPLAY]) {
            item.valueType = DISPLAY_TYPE.ARRAY_IDS;
          }
          this.generateDisplay(item, gridInfo);
          break;

        default:
          /* item.render = (value: any) => (
            <span className={`text-${gridInfo?.color || ''}`}>{value}</span>
          ) */
          break;
      }

      // enumable: Danh sách có sẵn
      if (gridInfo.enumable) {
        if (gridInfo.items && gridInfo.items.length > 0) {
          // bindButton: nút bấm thay thế trên table
          if (gridInfo.bindButton) {
            item.render = (value: any, row: any) => {
              const buttons = [];
              for (let i = 0; i < pageInfo.buttons.length; i++) {
                const btn = pageInfo.buttons[i];
                if (btn.column === gridInfo.field) {
                  if (btn.condition) {
                    if (
                      (btn.condition === '1' && value) ||
                      (btn.condition === '0' && !value)
                    ) {
                      buttons.push(this.renderBtn(btn, i, row));
                    }
                  } else {
                    buttons.push(this.renderBtn(btn, i, row));
                  }
                }
              }
              return buttons;
            };
          } else {
            const useTag =
              gridInfo[GRID_EDITOR_FIELD.ENUM_DISPLAY_AS] === 'tag';
            const hasStatus = gridInfo.items.find((i: any) => i.status);

            if (useTag) {
              // Tag + màu: render Tag, vẫn giữ valueEnum text để search/filter
              item.valueEnum = gridInfo.items.reduce((prev: any, cur: any) => {
                return {
                  ...prev,
                  [cur.value]: this.getEnumItemLabel(cur, currentLocale),
                };
              }, {});
              item.render = (_dom: any, record: any) => {
                const raw = _.get(record, gridInfo.field);
                if (raw == null || raw === '') return '-';
                const found = (gridInfo.items || []).find(
                  (i: any) => String(i.value) === String(raw)
                );
                const label = found
                  ? this.getEnumItemLabel(found, currentLocale)
                  : String(raw);
                const color = this.getEnumTagColor(found);
                return <Tag color={color}>{label}</Tag>;
              };
            } else if (hasStatus) {
              item.valueEnum = gridInfo.items.reduce((prev: any, cur: any) => {
                return {
                  ...prev,
                  [cur.value]: {
                    text: this.getEnumItemLabel(cur, currentLocale),
                    status: cur.status,
                    color: cur.color || '',
                    isText: cur.isText || false,
                  },
                };
              }, {});
            } else {
              item.valueEnum = gridInfo.items.reduce((prev: any, cur: any) => {
                return {
                  ...prev,
                  [cur.value]: this.getEnumItemLabel(cur, currentLocale),
                };
              }, {});
            }
          }
        } else {
          item.render = () => {
            return (
              <span className={`text-danger`}>
                {currentLocale === 'la'
                  ? 'ບໍ່ມີລາຍການ'
                  : currentLocale === 'en'
                    ? 'No Data'
                    : 'Chưa có dữ liệu'}
              </span>
            );
          };
        }
        // modelSelect: hiển thị dữ liệu lấy từ api
      } else if (gridInfo.modelSelect) {
        item.renderFormItem = (_: any, { type }: any) => {
          if (type === 'form') {
            return null;
          }
          return (
            <Widgets.ArraySelect
              type='checkbox'
              schema={{
                modelSelectField:
                  currentLocale === 'la'
                    ? 'id$$ID,name$$ຊື່'
                    : currentLocale === 'en'
                      ? 'id,name'
                      : 'id$$ID,name$$Tên',
                pageId: (this.pageInfo ?? {}).id,
                api: gridInfo.modelSelectApi,
              }}
            />
          );
        };
        item.render = (_dom: any, record: any): any => {
          // Use raw record value — ProTable first arg is already digit-formatted (e.g. 1.000.000)
          const value = record?.[gridInfo.field];
          const populateObj = this.state.modelSelect[gridInfo.field];
          const populateObjData = populateObj?.data ?? [];
          const matchId = (a: any, b: any) =>
            a != null && b != null && String(a) === String(b);

          // Xử lý ARRAY_IDS
          if (gridInfo.type === DATA_TYPE.ARRAY_IDS) {
            if (!_.isArray(value) || value.length === 0) {
              return <span>-</span>;
            }

            // Tìm các tên tương ứng với IDs
            const names = value.map((id: any) => {
              const found = populateObjData.find((item: any) =>
                matchId(item.id, id)
              );
              return found ? found.name : id;
            });

            // Hiển thị tối đa 1 items, nếu nhiều hơn thì thêm dấu 3 chấm
            if (names.length <= 1) {
              return (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                  {names.map((name: string, index: number) => (
                    <Tag key={index} color={gridInfo.color || COLORS[3]}>
                      {name}
                    </Tag>
                  ))}
                </div>
              );
            } else {
              return (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center' }}>
                  {names.slice(0, 1).map((name: string, index: number) => (
                    <Tag key={index} color={gridInfo.color || COLORS[3]}>
                      {name}
                    </Tag>
                  ))}
                  <Tooltip
                    title={
                      <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                        {names.map((name: string, index: number) => (
                          <div key={index} style={{ marginBottom: '4px' }}>
                            <Tag color={gridInfo.color || COLORS[3]} style={{ margin: '2px' }}>
                              {name}
                            </Tag>
                          </div>
                        ))}
                      </div>
                    }
                    placement="top"
                    overlayStyle={{ maxWidth: '300px' }}
                  >
                    <span
                      style={{
                        marginLeft: '4px',
                        color: '#1890ff',
                        cursor: 'pointer',
                        textDecoration: 'underline'
                      }}
                    >
                      +{names.length - 1}...
                    </span>
                  </Tooltip>
                </div>
              );
            }
          }


          for (let idx = 0; idx < populateObjData.length; idx++) {
            const populateTarget = populateObjData[idx];
            if (matchId(populateTarget[`id`], value)) {
              return (
                <Tag color={`${gridInfo.color || COLORS[3]}`}>
                  {populateTarget?.translations?.find(
                    (t: any) => t.language === currentLocale
                  )?.name || populateTarget[`name`]}
                </Tag>
              );
            }
          }
        };
      }
      // viewDetail: xem chi tiết
      if (gridInfo.viewDetail) {
        item.render = (val: any, record: any) => {
          const raw = _.get(record, gridInfo.field);
          const display =
            this.isPlainObjectValue(raw) && !gridInfo.modelSelect
              ? this.renderObjectCell(raw)
              : val;
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div style={{ textTransform: 'uppercase' }}>{display}</div>
              <a
                style={{ fontSize: '12px', marginLeft: '5px' }}
                onClick={() => {
                  this.setState({
                    viewDetail: {
                      ...this.state.viewDetail,
                      visible: true,
                      record,
                    },
                  });
                }}
              >
                <Tooltip title='Chi tiết'>
                  <EyeOutlined />
                </Tooltip>
              </a>
            </div>
          );
        };
      } else if (!item.render) {
        // Nested/object field display (vd: meta hoặc meta.note)
        item.render = (_dom: any, record: any) => {
          const raw = _.get(record, gridInfo.field);
          if (this.isPlainObjectValue(raw)) {
            return this.renderObjectCell(raw);
          }
          return _dom;
        };
      }

      // Wrap nhiều field vào 1 cột
      if (
        (gridInfo[GRID_EDITOR_FIELD.WRAP_FIELDS]?.length || 0) > 0 &&
        gridInfo.field !== COLUMN_ACTIONS_FIELD &&
        !gridInfo.bindButton
      ) {
        item.search = false;
        item.hideInSearch = true;
        item.render = (_dom: any, record: any) =>
          this.renderWrapFieldsCell(gridInfo, record);
      }

      // Prefix / Suffix quanh giá trị cột (cố định hoặc theo cột khác)
      if (
        (gridInfo[GRID_EDITOR_FIELD.PREFIX] ||
          gridInfo[GRID_EDITOR_FIELD.SUFFIX] ||
          gridInfo[GRID_EDITOR_FIELD.PREFIX_COLOR] ||
          gridInfo[GRID_EDITOR_FIELD.SUFFIX_COLOR] ||
          gridInfo[GRID_EDITOR_FIELD.PREFIX_BY_FIELD] ||
          gridInfo[GRID_EDITOR_FIELD.SUFFIX_BY_FIELD]) &&
        gridInfo.field !== COLUMN_ACTIONS_FIELD &&
        !gridInfo.bindButton
      ) {
        const prevRender = item.render;
        item.render = (dom: any, record: any, index: any, action: any) => {
          const content = prevRender
            ? prevRender(dom, record, index, action)
            : dom;
          return this.wrapWithAffix(content, gridInfo, record);
        };
      }

      columns.push(item);

      // Ô search riêng cho từng wrap field (filterable)
      if (
        (gridInfo[GRID_EDITOR_FIELD.WRAP_FIELDS]?.length || 0) > 0 &&
        gridInfo.field !== COLUMN_ACTIONS_FIELD
      ) {
        (gridInfo[GRID_EDITOR_FIELD.WRAP_FIELDS] || []).forEach((wf: any) => {
          const searchCol = this.buildWrapSearchColumn(wf, currentLocale);
          if (searchCol) {
            columns.push(searchCol);
          }
        });
      }
    }
    const colActions = (pageInfo.grid || []).find(
      (item: IGridEditorColumn) => item.field === COLUMN_ACTIONS_FIELD
    );
    if (pageInfo.buttons && pageInfo.buttons.length > 0) {
      const buttons: Array<IButtonEditor> = [];
      pageInfo.buttons.map((i: IButtonEditor) => {
        try {
          if (
            Array.isArray(i.roles) &&
            i.roles &&
            i.roles.length > 0 &&
            !i.roles.includes(this.props.authUser.roleId)
          ) {
            return;
          }
        } catch (error) {
          return;
        }
        if (
          (typeof i.type == 'undefined' || i.type === 'button') &&
          !i.column
        ) {
          return buttons.push(i);
        }
        return null;
      });
      if (buttons.length > 0) {
        columns.push({
          title: this.getActionTitle(currentLocale),
          fixed: 'right',
          render: (value: any, row: any) => {
            const btnToRender: Array<IButtonEditor> = [];
            buttons.map((item: IButtonEditor) => {
              if (item.column) return null;
              if (item.hideExpression) {
                let str = item.hideExpression;
                for (const i in row) {
                  str = helper.replaceAll(str, i, row[i]);
                }
                try {
                  if (window.eval(str)) return null;
                } catch (err) {
                  return null;
                }
              }
              btnToRender.push(item);
              return null;
            });

            if (
              colActions &&
              typeof colActions.menuButton == 'boolean' &&
              colActions.menuButton &&
              btnToRender.length >=
              (colActions.menuButtonConditon
                ? Number(colActions.menuButtonConditon)
                : DEFAULT_MENU_BUTTONS)
            ) {
              return this.renderMenuButton(btnToRender, row, colActions);
            }
            if (btnToRender.length === 1) {
              return (
                <div className='gx-d-flex gx-justify-content-center gx-align-items-center gx-align-self-center'>
                  {btnToRender.map((item: IButtonEditor, index: number) => {
                    return this.renderBtn(item, index, row);
                  })}
                </div>
              );
            }
            const btnItems = (
              <Menu
                onClick={() => {
                  //
                }}
              >
                {btnToRender.map((btnInfo: IButtonEditor, idx: number) => {
                  return (
                    <Menu.Item
                      key={
                        btnInfo.mode
                          ? `${btnInfo.mode}-action-btn-${row.id}-${idx + 1}`
                          : `menu-col-btn-${idx + 1}`
                      }
                    >
                      {this.renderBtn(btnInfo, idx + 1, row)}
                    </Menu.Item>
                  );
                })}
              </Menu>
            );
            return (
              <div className='gx-d-flex gx-justify-content-center gx-align-items-center gx-align-self-center'>
                <Dropdown overlay={btnItems}>
                  <Button>
                    {this.getActionTitle(currentLocale)} <DownOutlined />
                  </Button>
                </Dropdown>
              </div>
            );
          },
        });
      }
    }
    return columns;
  };

  onSwitch = async (btnInfo: any, row: any, val: any) => {
    const locale = getLang();
    const currentLocale = locale.split('-')[0];
    try {
      await helper.callPageApi(this.pageInfo, btnInfo.api, {
        id: row.id,
        [btnInfo.column]: val,
      });
      this.reloadTable();
      helper.alert(currentLocale === 'la' ? 'ດຳເນີນການສຳເລັດ' : currentLocale === 'en' ? 'Action completed' : 'Thành công', 'success');
    } catch (err) {
      helper.alert(currentLocale === 'la' ? 'ມີຂໍ້ຜິດພາດ' : currentLocale === 'en' ? 'There is an error' : 'Đã có lỗi xảy ra', 'error');
    }
  };

  renderBtn = (
    item: IButtonEditor,
    index: number,
    row: { [x: string]: any }
  ) => {
    if (
      item.roles &&
      Array.isArray(item.roles) &&
      item.roles.length > 0 &&
      !item.roles.includes(this.props.authUser.roleId)
    ) {
      return null;
    }
    if (item.hideExpression) {
      let str = item.hideExpression;
      for (const i in row) {
        str = helper.replaceAll(str, i, row[i]);
      }
      try {
        if (window.eval(str)) return null;
      } catch (err) {
        return null;
      }
    }
    if (item.condition) {
      let str = item.condition;
      for (const i in row) {
        str = helper.replaceAll(str, i, row[i]);
      }
      try {
        if (!window.eval(str)) return null;
      } catch (err) {
        //
      }
    }
    let disabled = false;
    if (item.disableExpression) {
      let str = item.disableExpression;
      for (const i in row) {
        str = helper.replaceAll(str, i, row[i]);
      }
      try {
        if (window.eval(str)) disabled = true;
      } catch (err) {
        disabled = true;
      }
    }

    switch (item.type) {
      case 'switch':
        return (
          <Widgets.Checkbox
            disabled={disabled}
            key={`${item.mode}-action-btn-${index}`}
            value={row[item.column as string]}
            onChange={(evt: any) => {
              this.onSwitch(item, row, evt);
            }}
          />
        );
      default: {
        switch (item.action) {
          case 'url': {
            let url: string = (item?.url ?? '').replace('$', row.id);
            for (const i in row) {
              url = helper.replaceAll(url, '#' + i + '#', row[i]);
            }
            for (const i in this.props.query) {
              url = helper.replaceAll(url, '@' + i + '@', this.props.query[i]);
            }
            return defaultRenderButton(
              {
                ...item,
                url,
              },
              {},
              `${item.mode}-action-btn-${index}`
            );
          }
          case 'api':
          case 'formModal': {
            return defaultRenderButton(
              item,
              {
                disabled,
                onClick: () => {
                  this.onButtonClick(item, row);
                },
              },
              `${item.mode}-action-btn-${index}`
            );
          }
          case 'report': {
            return this.renderReportButton(item);
          }
          default:
            return null;
        }
      }
    }
  };

  renderReportButton = (item: IButtonEditor) => {
    const locale = getLang();
    const currentLocale = locale.split('-')[0];
    const disabled = false;
    const itemExcel: IButtonEditor = Object.assign({}, item);
    const itemCSV: IButtonEditor = Object.assign({}, item);
    switch (currentLocale) {
      case 'la':
        itemExcel.title = 'ໄຟລ໌ Excel';
        itemCSV.title = 'ໄຟລ໌ CSV';
        break;
      case 'en':
        itemExcel.title = 'Excel File';
        itemCSV.title = 'CSV File';
        break;
      default:
        itemExcel.title = 'Tệp Excel';
        itemCSV.title = 'Tệp CSV';
        break;
    }
    const menu = (
      <Menu
        onClick={() => {
          //
        }}
      >
        <Menu.Item
          key={item.mode ? `${item.mode}-action-btn-${0}` : `menu-col-btn-${0}`}
        >
          {defaultRenderButton(
            itemExcel,
            {
              disabled,
              onClick: () => {
                this.onReportClick(itemExcel, 'excel', currentLocale);
              },
            },
            `${itemExcel.mode}-action-btn-${0}`
          )}
        </Menu.Item>
        <Menu.Item
          key={item.mode ? `${item.mode}-action-btn-${1}` : `menu-col-btn-${0}`}
        >
          {defaultRenderButton(
            itemCSV,
            {
              disabled,
              onClick: () => {
                this.onReportClick(itemCSV, 'csv', currentLocale);
              },
            },
            `${itemCSV.mode}-action-btn-${1}`
          )}
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown overlay={menu}>
        <Button>
          <Space>
            {currentLocale === 'la'
              ? 'ດື່ງລາຍງານ'
              : currentLocale === 'en'
                ? 'Export report'
                : 'Xuất báo cáo'}
            <DownOutlined />
          </Space>
        </Button>
      </Dropdown>
    );
  };

  renderMenuButton = (
    dataButton: Array<any>,
    row: { [x: string]: any },
    colActions: IGridEditorColumn
  ) => {
    const menu = (
      <Menu
        onClick={() => {
          //
        }}
      >
        {dataButton.map((btnInfo: IButtonEditor, idx: number) => {
          return (
            <Menu.Item
              key={
                btnInfo.mode
                  ? `${btnInfo.mode}-action-btn-${idx}`
                  : `menu-col-btn-${idx}`
              }
            >
              {this.renderBtn(btnInfo, idx, row)}
            </Menu.Item>
          );
        })}
      </Menu>
    );
    return (
      <Dropdown.Button
        overlay={menu}
        title={colActions.name || COLUMN_ACTIONS_NAME}
      >
        {colActions.name || COLUMN_ACTIONS_NAME}
      </Dropdown.Button>
    );
  };

  onReportClick = async (btn: any, type: any, currentLocale?: string) => {
    let url = helper.getReportUrl(
      this.pageInfo,
      btn.api,
      this.state.currentFilter,
      currentLocale
    );
    url += `&type=${type}`;
    window.open(process.env.REACT_APP_URL + url, '_blank');
  };

  onRequestError = (error: any) => {
    if (IS_DEBUG) {
      console.log(
        `🚀 ~ file: ListCtrl.tsx ~ line 943 ~ ListCtrl ~ error`,
        error
      );
    }
  };

  toolBarRender = () => {
    const buttons = ((this.pageInfo || {}).buttons || []).map(
      (item: any, index: number) => {
        if (item.type !== 'submit') return null;
        return this.renderBtn(item, index, {});
      }
    );
    return [...buttons];
  };

  render() {
    const { currentModal: EditModal } = this.state;
    const locale = getLang();
    const currentLocale = locale.split('-')[0];
    const ViewDetail = detailTemplates[this.state.viewDetail.viewDetailCtrl];
    if (this.state.error)
      return <p className='text-danger'>{this.state.error}</p>;
    if (!this.state.pageInfo || !this.state.columns.length) return <Loader />;
    return (
      <>
        <Row>
          <Col md={24}>
            <Modal
              width={`80vw`}
              visible={this.state.isShowModal}
              footer={null}
              onCancel={() => {
                this.reloadTable();
                this.setState({ isShowModal: false });
              }}
              title={
                <>
                  {this.props.query.name
                    ? this.props.query.name
                    : currentLocale === 'la'
                      ? (this.pageInfo || {}).nameLa || (this.pageInfo || {}).name
                      : currentLocale === 'en'
                        ? (this.pageInfo || {}).nameEn || (this.pageInfo || {}).name
                        : (this.pageInfo || {}).name}
                </>
              }
              destroyOnClose={true}
            >
              <>
                {this.state.currentModal ? (
                  <EditModal
                    query={this.state.modalQuery}
                    onClose={() => {
                      this.reloadTable();
                      this.setState({ isShowModal: false });
                    }}
                  />
                ) : (
                  <Loader />
                )}
              </>
            </Modal>
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <ProTable
              actionRef={this.actionRef as any}
              bordered={
                this?.pageInfo?.settings?.grid?.bordered ||
                defaultGridSetting.bordered
              }
              type='table'
              tableClassName='gx-table-responsive'
              dateFormatter='string'
              components={{
                header: {
                  cell: ResizableHeaderTitle,
                },
              }}
              headerTitle={
                this.props.query.name
                  ? this.props.query.name
                  : currentLocale === 'la'
                    ? (this.pageInfo || {}).nameLa || (this.pageInfo || {}).name
                    : currentLocale === 'en'
                      ? (this.pageInfo || {}).nameEn || (this.pageInfo || {}).name
                      : (this.pageInfo || {}).name
              }
              rowKey={this.state.key || 'id'}
              formRef={this.form}
              scroll={{
                scrollToFirstRowOnChange: true,
                x: 'max-content',
              }}
              tableLayout='auto'
              search={true}
              tableAlertRender={false}
              loading={this.state.loading}
              onChange={this.onTableChange}
              request={this.fetchData}
              onRequestError={this.onRequestError}
              pagination={this.state.pagination}
              columns={this.state.columns}
              columnsStateMap={this.state.columnsStateMap}
              onColumnsStateChange={(mapCols) => {
                // Giữ freeze theo config GridEditor khi user đổi column setting
                const nextMap = { ...mapCols };
                (this.pageInfo?.grid || []).forEach((g: any) => {
                  const field = g?.[GRID_EDITOR_FIELD.FIELD];
                  if (!field || !nextMap[field]) return;
                  if (
                    g[GRID_EDITOR_FIELD.FIXED] &&
                    g[GRID_EDITOR_FIELD.FIXED] !== 'none'
                  ) {
                    nextMap[field] = {
                      ...nextMap[field],
                      fixed: g[GRID_EDITOR_FIELD.FIXED],
                    };
                  }
                });
                this.setState({
                  columnsStateMap: nextMap,
                });
              }}
              toolBarRender={this.toolBarRender}
            />
          </Col>
        </Row>
        {this.state.viewDetail.hasDetail && ViewDetail && (
          <ViewDetail
            query={this.props.query}
            pageInfo={this.state.pageInfo}
            drawerVisible={this.state.viewDetail.visible}
            record={this.state.viewDetail.record}
            onClose={(v: boolean) => {
              this.setState({
                viewDetail: {
                  ...this.state.viewDetail,
                  visible: v,
                },
              });
            }}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = ({ auth }: StoreState) => {
  const { authUser } = auth;
  return { authUser };
};
export default connect(mapStateToProps)(ListCtrl);

// export default ListCtrl
